import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../components/commons";
import { RootState } from "../../redux/rootReducers";
import {
  GetAllFinacUserPayloadType,
  GetTeamDirectoryPayloadType,
} from "../../commonTypes/authTypes";
import {
  getAllFinacUsersAction,
  getTeamDirectoryUserListAction,
  resetAuthError,
  resetAuthSuccess,
  resetFinacUsersList,
  resetSession,
  resetTeamDirectoryTotalCount,
  resetTeamDirectoryUsersList,
  resetTotalUserCount,
  resetUserProfileAllData,
  userProfileAction,
} from "../../redux/auth";
import { connect } from "react-redux";
import { SearchIcon } from "../../components/Icon";
import { EmptyList } from "../../assets/images";
import TeamDirectoryTable from "../../components/TeamDirectory/TeamDirectoryTable";
import {
  TeamDirectoryUsersType,
  UserProfileType,
} from "../../redux/auth/authTypes";
import ViewTeamDirectoryDetails from "../../components/TeamDirectory/ViewTeamDirectoryDetails";
import useDebounce from "../../customHooks/useDebounce";
import TeamDirectoryFilter from "../../components/TeamDirectory/TeamDirectoryFilter";
import { DropDownUserType } from "../Jobs/RecurringJobReport";
import { GetAllMasterDataBranchPayloadType, GetMasterDataListPayloadType } from "../../commonTypes/masterDataTypes";
import { getAllMasterDataBranchAction, getMasterDataSkillsModuleAction } from "../../redux/masterData";
import { DropDownType } from "../../commonTypes/clientDirectoryTypes";
import { skillMasterDataListType } from "../../redux/masterData/masterTypes";

type AppProps = {
  fetching: boolean;
  token: string | null;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  branchFetching: boolean;
  branchDataList: any;
  masterDataBranchListTotal: string | number;
  skillMasterDataList: skillMasterDataListType[] | [];
  skillsMasterDataTotalCount: number;
  dispatchResetSession: () => void;
  dispatchResetError: () => void;
  dispatchResetAuthSuccess: () => void;
  dispatchTeamDirectoryUsersAction: (data: GetTeamDirectoryPayloadType) => void;
  totalUserCount: string | number;
  allFinacUsersList: any;
  dispatchResetUserProfileAllData: () => void;
  dispatchResetUserDetails: () => void;
  dispatchResetTotalUserCount: () => void;
  dispatchUserProfileData: (data: any) => void;
  dispatchResetTeamDirectoryList: () => void;
  userProfileAllData: UserProfileType;
  teamDirectoryList: TeamDirectoryUsersType[];
  dispatchGetAllMasterDataBranchListAction: (data: GetAllMasterDataBranchPayloadType) => void;
  dispatchGetMasterDataSkillsModuleAction: (
    data: GetMasterDataListPayloadType
  ) => void;
  skillFetching: boolean;
};
const TeamDirectory = ({
  fetching,
  token,
  success,
  error,
  statusCode,
  branchFetching,
  branchDataList,
  masterDataBranchListTotal,
  skillMasterDataList,
  skillsMasterDataTotalCount,
  dispatchResetSession,
  dispatchResetError,
  dispatchResetAuthSuccess,
  dispatchTeamDirectoryUsersAction,
  totalUserCount,
  allFinacUsersList,
  dispatchResetTotalUserCount,
  dispatchResetUserProfileAllData,
  dispatchResetUserDetails,
  dispatchUserProfileData,
  dispatchResetTeamDirectoryList,
  userProfileAllData,
  teamDirectoryList,
  dispatchGetAllMasterDataBranchListAction,
  dispatchGetMasterDataSkillsModuleAction,
  skillFetching,
}: AppProps) => {
  const [userOffset, setUserOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [userData, setUserData] = useState<any>([]);
  const [showTeamDetails, setShowTeamDetails] = useState<boolean>(false);
  const [userSearchData, setUserSearchData] = useState<string>("");
  const [userSearchClear, setUserSearchClear] = useState(false);
  const [toggleFilter, setToggleFilter] = useState<boolean>(false);
  const [loadCondition, setLoadCondition] = useState<boolean>(true);
  // BRANCH
  const [branchOffset, setBranchOffset] = useState<number>(0);
  const [branchText, setBranchText] = useState<string>("");
  const [branch, setBranch] = useState<DropDownUserType[]>([
    {
      value: null,
      label: "All Branches",
    },
  ]);
  const [finalBranchDataList, setFinalBranchDataList] = useState<any>([]);
  const [activeListBranch, setActiveListBranch] = useState<DropDownUserType>({
    value: null,
    label: "Select...",
  });
  const [listBranch, setListBranch] = useState<DropDownUserType>({
    value: null,
    label: "Select...",
  });

  // SKILL 
  const [skillsText, setSkillsText] = useState<string>("");
  const [skillsOffset, setSkillsOffset] = useState<number>(0);
  const [finalSkillList, setFinalSkillList] = useState<DropDownType[] | []>([]);
  const [selectedSkill, setSelectedSkill] = useState<DropDownType[] | []>([]);
  const [finalSelectedSkills, setFinalSelectedSkills] = useState<DropDownType[] | []>([]);

  const [clearFilter, setClearFilter] = useState<boolean>(false);
let skillsValue = finalSelectedSkills?.map((id: any) => id.value);
  useEffect(() => {
    setUserData([]);
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetAuthSuccess();
    dispatchResetError();
    dispatchResetUserProfileAllData();
    // dispatchResetUserDetails();
    dispatchResetTeamDirectoryList();
    dispatchResetTotalUserCount();
    if (userOffset > 0) {
      setUserOffset(0);
    }
  }, []);

  useEffect(() => {
    if (teamDirectoryList?.length === 0) {
      setUserData(teamDirectoryList);
    } else if (userOffset > 0 && userData?.length > 0) {
      setUserData((prv: any) => [...prv, ...teamDirectoryList]);
    } else {
      setUserData(teamDirectoryList);
    }
  }, [teamDirectoryList]);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        limit,
        offset: userOffset,
        search_term: userSearchData,
        branch_filter: listBranch?.value?.toString(),
        skill_filter: skillsValue
      };

      if (totalUserCount) {
        if (+totalUserCount > userOffset) {
          dispatchTeamDirectoryUsersAction(finalData);
        }
      } else {
        dispatchTeamDirectoryUsersAction(finalData);
      }
    }
  }, [userOffset]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: branchOffset,
        limit,
        search_term: branchText,
        branch_status: 1
      };
      if(branchOffset <= +masterDataBranchListTotal) {
        dispatchGetAllMasterDataBranchListAction(finalUserData);
      }
    }
  }, [branchOffset])

  useEffect(() => {
    const branchData = branchDataList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.branch_name,
      };
    });
    if(branchOffset > 0){
      setFinalBranchDataList([...finalBranchDataList, ...branchData]);
    } else {
      setFinalBranchDataList(branchData);
    }
  }, [branchDataList]);

  const fetchNewBranchData= (search: string) => {
    const finalData = {
      token,
      offset: branchOffset,
      limit,
      search_term: branchText,
      branch_status: 1,
    };
    dispatchGetAllMasterDataBranchListAction(finalData);
  };
  useEffect(() => {
    const skillsData = skillMasterDataList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.skill_name,
      };
    });
    if (skillsOffset > 0) {
      setFinalSkillList([...finalSkillList, ...skillsData]);
    } else {
      setFinalSkillList(skillsData);
    }
  }, [skillMasterDataList]);

  useEffect(() => {
    if(token) {
      let finalData = {
        token,
        searchValue: skillsText,
        limit,
        offset: skillsOffset,
        status: 1
      };
      if(skillsOffset <= +skillsMasterDataTotalCount) {
        dispatchGetMasterDataSkillsModuleAction(finalData)
      }
    }
  }, [skillsOffset]);

  const fetchNewSkillsData = (search: string) => {
    let finalData = {
      token,
      searchValue: skillsText,
      limit,
      offset: skillsOffset,
      status: 1,
    };
    dispatchGetMasterDataSkillsModuleAction(finalData);
  };

  useDebounce(() => {
    if(skillsText) {
      fetchNewSkillsData(skillsText);
    } else {
      let finalData = {
        token,
        searchValue: skillsText,
        limit,
        offset: skillsOffset,
        status: 1
      };
      dispatchGetMasterDataSkillsModuleAction(finalData);
    }
  }, 500, [skillsText]);

  useEffect(() => {
    if(listBranch?.value || skillsValue?.length ){
      fetchNewData()
    }
  }, [listBranch, finalSelectedSkills])

  useEffect(() => {
    if(clearFilter) {
      fetchNewData();
    }
  }, [clearFilter]);
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        !fetching &&
        userOffset < +totalUserCount &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (teamDirectoryList?.length > 0) {
          if (!fetching && userOffset < +totalUserCount) {
            setUserOffset(userOffset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (userSearchClear) {
      let finalData = {
        token,
        limit,
        offset: userOffset,
        search_term: userSearchData,
        branch_filter: listBranch?.value?.toString(),
        skill_filter: skillsValue
      };
      if (userSearchData?.length === 0) {
        // dispatchResetUserDetails();
        dispatchResetTeamDirectoryList();
        dispatchTeamDirectoryUsersAction(finalData);
        setUserOffset(0);
      }
    }
  }, [userSearchClear, userSearchData]);

  useDebounce(() => {
    if(branchText){
      fetchNewBranchData(branchText);
    } else {
      const finalData = {
        token,
        offset: branchOffset,
        limit,
        search_term: branchText,
        branch_status: 1,
      };
      dispatchGetAllMasterDataBranchListAction(finalData);
    }
  }, 500, [branchText]);
  useDebounce(
    () => {
      if (userSearchData) {
        fetchNewData();
      }
    },
    500,
    [userSearchData]
  );

  const fetchNewData = () => {
    setUserData([]);
    // dispatchResetUserDetails();
    dispatchResetTeamDirectoryList();
    dispatchResetTotalUserCount();
    let finalData = {
      token,
      limit,
      offset: userOffset,
      search_term: userSearchData,
      branch_filter: listBranch?.value?.toString(),
      skill_filter: skillsValue
    };
    if (token) {
      setUserSearchClear(true);

      if (userOffset === 0) {
        dispatchTeamDirectoryUsersAction(finalData);
        setUserOffset(0);
      } else {
        setUserOffset(0);
      }
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [teamDirectoryList]);

  const handleShowUserDetails = (data: any) => {
    if (token) {
      let final_data = {
        token,
        user_id: data?.user_id,
      };
      dispatchUserProfileData(final_data);
    }
    setShowTeamDetails(true);
  };
  const toggleTeamDetails = () => {
    setShowTeamDetails(false);
  };
  const handleSearchUser = (e: any) => {
    setUserSearchData(e.target.value);
  };
  const checkBranchBottom = (e: any) => {
    setLoadCondition(false);
    setBranchOffset((prv: any) => prv + limit);
  };
  const checkSkillsBottom = (e: any) => {
    setLoadCondition(false);
    setSkillsOffset((prv: any) => prv + limit);
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader title="Team Directory" />
      </div>
      <div className="col-md-12">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">Team Directory List</div>
              {!fetching && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  totalUserCount ? totalUserCount : 0
                } users found`}</div>
              )}
            </div>
            <div className="right-header">
              <div
                className={"col-md-10 position-relative"}
              >
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e: any) => handleSearchUser(e)}
                  style={{ paddingLeft: "35px" }}
                  value={userSearchData}
                />
              </div>
              <div>
                <TeamDirectoryFilter
                setListBranch={setListBranch}
                listBranch={listBranch}
                setActiveListBranch={setActiveListBranch}
                activeListBranch={activeListBranch}
                setClearFilter={setClearFilter}
                setOffset={setBranchOffset}
                finalBranchDataList={finalBranchDataList}
                branch={branch}
                branchFetching={branchFetching}
                setBranchText={setBranchText}
                checkBranchBottom={checkBranchBottom}
                toggle={toggleFilter}
                setToggle={setToggleFilter}
                skillsText={skillsText}
                finalSkillList={finalSkillList}
                setSkillsOffset={setSkillsOffset}
                setSkillsText={setSkillsText}
                checkSkillsBottom={checkSkillsBottom}
                selectedSkill={selectedSkill}
                setSelectedSkill={setSelectedSkill}
                finalSkill={finalSelectedSkills}
                selectedFinalSkill={setFinalSelectedSkills}
                skillFetching={skillFetching}
                />
              </div>
            </div>
          </div>
          <div>
            {fetching && userOffset == 0 && !showTeamDetails ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : userData?.length > 0 ? (
              <TeamDirectoryTable
                data={userData}
                fetching={fetching}
                offset={userOffset}
                handleShowUserDetails={handleShowUserDetails}
              />
            ) : (
              <div className="mt-5 pb-5">
                {!fetching && userData?.length === 0 && (
                  <EmptyListPage
                    title="No Team List Found!"
                    image={EmptyList}
                    imageWidth="30%"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {showTeamDetails && (
        <ViewTeamDirectoryDetails
          isRight={true}
          isOpen={showTeamDetails}
          onClose={toggleTeamDetails}
          userProfileAllData={userProfileAllData}
          fetching={fetching}
        />
      )}
      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  fetching: state.auth.fetching,
  success: state.auth.success,
  error: state.auth.error,
  statusCode: state.auth.statusCode,
  token: state.auth.token,
  totalUserCount: state.auth.totalTeamDirectoryUsersCount,
  userProfileAllData: state.auth.userProfileAllData,
  teamDirectoryList: state.auth.teamDirectoryUsersData,
  branchFetching: state.masterData.fetching,
  branchDataList: state.masterData.masterDataListing,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
  skillMasterDataList: state.masterData.skillMasterDataList,
  skillsMasterDataTotalCount: state.masterData.skillsMasterDataTotalCount,
  skillFetching: state.masterData.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchTeamDirectoryUsersAction: (data: GetTeamDirectoryPayloadType) =>
    dispatch(getTeamDirectoryUserListAction(data)),
  dispatchResetError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),

  dispatchResetSession: () => dispatch(resetSession()),

  dispatchResetUserProfileAllData: () => dispatch(resetUserProfileAllData()),
  dispatchResetUserDetails: () => dispatch(resetFinacUsersList()),
  dispatchUserProfileData: (data: any) => dispatch(userProfileAction(data)),
  dispatchResetTeamDirectoryList: () => dispatch(resetTeamDirectoryUsersList()),
  dispatchResetTotalUserCount: () => dispatch(resetTeamDirectoryTotalCount()),
  dispatchGetAllMasterDataBranchListAction: (data: GetAllMasterDataBranchPayloadType) => 
      dispatch(getAllMasterDataBranchAction(data)),
  dispatchGetMasterDataSkillsModuleAction: (
      data: GetMasterDataListPayloadType
    ) => dispatch(getMasterDataSkillsModuleAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamDirectory);
